import { render, staticRenderFns } from "./modal-card.vue?vue&type=template&id=7ff10826"
import script from "./modal-card.vue?vue&type=script&lang=js"
export * from "./modal-card.vue?vue&type=script&lang=js"
import style0 from "./modal-card.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports